export default {
  expand: '展开',
  show: '收起',
  button: {
    submit: '确认',
    reset: '重置',
  },
};
